import MessageCodeBox from './index.vue'

MessageCodeBox.install = function (Vue) {
  Vue.component(MessageCodeBox.name, MessageCodeBox)
}

export default MessageCodeBox
